import { transformStringToIdIfIsBase64 } from '@app/utils/formats';

export const shouldReturnSessionStorageParam = (urlParams, savedParams) => !!savedParams && urlParams.size === 0;

export const getQueryParams = (searchString) => {
    const savedParams = JSON.parse(window.sessionStorage.getItem('params') || '{}');

    if (!searchString || searchString === "?") {
        return savedParams;
    }

    const urlParams = new URLSearchParams(searchString);

    const getSolutionId = () => {
        const fromUrl = urlParams.get('solutionId');
        if (fromUrl) return fromUrl;

        const match = searchString.match(/[?&]solutionId=([^&]*)/);
        if (match?.[1]) return decodeURIComponent(match[1]);

        return savedParams.solutionId || null;
    };

    const params = {
        solutionId: getSolutionId(),
        allowResume: urlParams.get('resume') !== 'false',
        parameters: (() => {
            const paramsString = urlParams.get('params');
            return paramsString ? JSON.parse(decodeURIComponent(paramsString)) : {};
        })(),
    };

    if (params.solutionId) {
        window.sessionStorage.setItem('params', JSON.stringify(params));
    }

    return params;
};

export const briefRoute = (participationId = ':participationId') => `/brief/${participationId}`;

export const sequenceRoute = (participationId = ':participationId', sequenceId = ':id') => `${briefRoute(participationId)}/sequence/${sequenceId}`;

export const parseParticipationId = (path) => {
    const pathSegments = path.split('/');

    if (pathSegments.indexOf('brief') === -1) {
        return null;
    }

    const participationIdIndex = pathSegments.indexOf('brief') + 1;
    return pathSegments[participationIdIndex] ? transformStringToIdIfIsBase64(pathSegments[participationIdIndex]) : null;
}
